import { Button, FormControlLabel, Radio, RadioGroup } from 'material-ui';
import LeftArrowIcon from 'material-ui-icons/ArrowBack';
import RightArrowIcon from 'material-ui-icons/ArrowForward';
import EventIcon from 'material-ui-icons/Event';
import { DatePicker } from 'material-ui-pickers';
import { CircularProgress } from 'material-ui/Progress';
import { withStyles } from 'material-ui/styles';
import React from 'react';
import { translate } from 'react-i18next';
import AbstractSearchForm from '../AbstractSearchForm';
import FullTextSearchField from '../FullTextSearchField';
import Room from '../Room';
import { setSelectedSuggestionFactory } from './../CommonFunctions';
import SearchTransferController from './SearchTransferController';
import { registerLandScapeForm } from '../../Utils/FilterChangeFunctions';
import DynIcon from '../../Utils/DynIcon';
import TimePicker from '../TimePicker';
import moment from 'moment';

let temp = Array.from(Array(46).keys());
temp.shift();
const adultValues = temp;
const kidsValues = Array.from(Array(21).keys());

const styles = theme => ({
    avatar: {
        backgroundColor: 'dark-grey',
        color: 'grey',
    },
    inputLabel: {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
    },
    roomNumberTextField: {
        width: '140px',
        marginBottom: '32px',
    },
    footNoteText: {
        marginTop: '16px',
        fontWeight: 300,
        paddingTop: 0
    },
    dialogTitle: {
        fontWeight: '300',
        fontSize: '24px'
    },
    main: {
        backgroundColor: 'transparent',
        paddingLeft: '8px'
    },
    menu: {
        zIndex: '9999',
    },
    coloredIcon: {
        color: theme.palette.icon.main + '!important',
        marginRight: '-24px'
    },
    coloredIconIE: {
        color: theme.palette.icon.main + '!important',
        marginTop: '-20px',
        paddingBottom: '5px'
    },
});

const roomsValues = Array.from(Array(6).keys());
roomsValues.shift();

class LandscapeSearchTransfer extends AbstractSearchForm {

    constructor(props) {
        super(props);
        this.controller = new SearchTransferController(this.props, this);
        this.state = this.controller.getInitialState();
        registerLandScapeForm(this);
    }

    handleUpdate = (action, data) => {
        switch (action) {
            case 'result':
                this.setState({ loading: false });
                this.controller.setStateFromQuery(data, this);
                break;
            default:
                break;
        }
    }

    UNSAFE_componentWillReceiveProps = (nextProps) => {
        if (nextProps) {
            if (nextProps.searchContentState) {
                let sta = this.state;
                sta = Object.assign(sta, nextProps.searchContentState);
                let room = sta.rooms[0];
                room.kids = nextProps.searchContentState.kids;
                room.adults = nextProps.searchContentState.adults;

                sta.from = nextProps.searchContentState.from;
                sta.to = nextProps.searchContentState.to;
                sta.reservation = nextProps.searchContentState.reservation;
                sta.datePickerStatus = this.controller.isAvailabilityTypeOneWay(nextProps.searchContentState.transferType);
                this.setState(sta);
            }
        }
    }

    render() {
        const { classes, t } = this.props;
        let room = this.state.rooms[0];
        const loadingCSS = this.state.loading ? ' blur' : '';
        return (
            <div className="LandscapeSearchTransfer">
                <table width="100%" className={'cmsTable' + loadingCSS}>
                    <tbody>
                        <tr>
                            <td className="fts">
                                <FullTextSearchField
                                    setSelectedSuggestion={this.controller.originSelected}
                                    endpoint="transfers/origin/fts"
                                    value={this.state.from}
                                    selectedSuggestion={this.state.from}
                                    inputError={this.state.inputError}
                                    autofocus={false}
                                    placeHolder={'TRANSFERS.AIRPORT_ZONE_HOTEL_NAME'}
                                    label={'COMMON.FROM'}
                                />
                            </td>
                            <td>
                                <DatePicker
                                    keyboard
                                    label={t('TRANSFERS.DATE_FROM')}
                                    className="cmsFormContainer"
                                    format={'DD/MM/YYYY'}
                                    leftArrowIcon={<LeftArrowIcon />}
                                    rightArrowIcon={<RightArrowIcon />}
                                    disablePast
                                    autoOk
                                    InputLabelProps={{
                                        className: classes.inputLabelDate,
                                    }}
                                    keyboardIcon={
                                        <EventIcon className="cmsIcon" />
                                    }
                                    value={this.state.fromDateTime}
                                    onChange={this.controller.handleDateChange}
                                />
                            </td>
                            <td>
                                <TimePicker
                                    margin="normal"
                                    label={t('TRANSFERS.HOUR_FROM')}
                                    className=""
                                    hourValue={moment.utc(this.state.fromDateTime).hour()}
                                    minutesValue={moment.utc(this.state.fromDateTime).minutes()}
                                    onChange={this.controller.handleHourChange}
                                >
                                </TimePicker>
                            </td>
                            <td>
                                <RadioGroup
                                    aria-label="Transfer Type"
                                    row={true}
                                    name="transferType"
                                    onChange={this.controller.handleTransferTypeChange}
                                    value={this.state.transferType}>
                                    <FormControlLabel value="roundtrip" labelplacement="end" control={<Radio className="cmsIcon" />} label={t('TRANSFERS.ROUND_TRIP')} />
                                    <FormControlLabel value="oneway" labelplacement="end" control={<Radio className="cmsIcon" />} label={t('TRANSFERS.ONE_WAY')} />
                                </RadioGroup>
                            </td>
                            <td className="search">
                                <Button color="primary"
                                    disabled={this.state.loading}
                                    onClick={this.controller.submit}
                                    title={t('HOME.SEARCH_BUTTON')}
                                    className="cmsButtonSearch">
                                    {this.state.loading
                                        ? <CircularProgress className="buttonProgressIcon" />
                                        :
                                        <DynIcon icon="Search"
                                            style={{
                                                color: 'var(--primary-button--text-color)',
                                                minWidth: '38px',
                                                height: '38px',
                                            }}
                                        />
                                    }
                                </Button>
                            </td>
                        </tr>
                        <tr>
                            <td className="fts">
                                <FullTextSearchField
                                    setSelectedSuggestion={setSelectedSuggestionFactory(this, 'to')}
                                    endpoint="transfers/destination/fts"
                                    className={this.state.datePickerStatus ? 'disabled' : ''}
                                    componentRef={this.controller.destinationFTS}
                                    value={this.state.to}
                                    selectedSuggestion={this.state.to}
                                    inputError={this.state.inputError}
                                    autofocus={false}
                                    placeHolder={'TRANSFERS.AIRPORT_ZONE_HOTEL_NAME'}
                                    label={'COMMON.TO'}
                                    originCode={this.state ? this.controller.getOriginZone(this.state.from) : ''}
                                />
                            </td>
                            <td>
                                <DatePicker
                                    keyboard
                                    label={t('TRANSFERS.DATE_TO')}
                                    className={'cmsFormContainer ' + (this.state.datePickerStatus ? 'disabled' : '')}
                                    format={'DD/MM/YYYY'}
                                    leftArrowIcon={<LeftArrowIcon />}
                                    rightArrowIcon={<RightArrowIcon />}
                                    disablePast
                                    autoOk
                                    InputLabelProps={{
                                        className: classes.inputLabelDate,
                                    }}
                                    keyboardIcon={
                                        <EventIcon className="cmsIcon" />
                                    }
                                    value={this.state.toDateTime}
                                    onChange={this.controller.handleToDateChange}
                                    disabled={this.state.datePickerStatus}
                                />
                            </td>
                            <td>
                                <TimePicker
                                    margin="normal"
                                    label={t('TRANSFERS.HOUR_TO')}
                                    className=""
                                    hourValue={moment.utc(this.state.toDateTime).hour()}
                                    minutesValue={moment.utc(this.state.toDateTime).minutes()}
                                    onChange={this.controller.handleToHourChange}
                                    disabled={this.state.datePickerStatus}
                                />
                            </td>
                            <td colSpan="2">
                                <Room
                                    key={1}
                                    mainClass={classes.main}
                                    number={0}
                                    adultValues={adultValues}
                                    kidsValues={kidsValues}
                                    {...room}
                                    handleAdultChange={this.handleAdultChange}
                                    handleKidsChange={this.handleKidsChange}
                                    handleKidsAgeChange={this.handleKidsAgeChange}
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }
}


export default translate('translations')(withStyles(styles)(LandscapeSearchTransfer));


// WEBPACK FOOTER //
// ./src/components/SearchContent/Transfers/LandscapeSearchTransfer.js